export const VIEWING_UPDATES_PAGE_SIZE = 20

export const VIEWING_UPDATE_ACTION = {
  book: 'book',
  create: 'create',
  statusCancelled: 'status_cancelled',
  statusCompleted: 'status_completed',
  statusNoShow: 'status_no_show',
}

export const VIEWING_UPDATE_ACTION_TRANSLATION_KEY = {
  [VIEWING_UPDATE_ACTION.book]: 'RentalPortal.ViewingUpdateBookedKey',
  [VIEWING_UPDATE_ACTION.create]: 'RentalPortal.ViewingUpdateCreatedKey',
  [VIEWING_UPDATE_ACTION.statusCancelled]:
    'RentalPortal.ViewingUpdateCancelledKey',
  [VIEWING_UPDATE_ACTION.statusCompleted]:
    'RentalPortal.ViewingUpdateCompletedKey',
  [VIEWING_UPDATE_ACTION.statusNoShow]: 'RentalPortal.ViewingUpdateNoShowKey',
}
